import styled from 'styled-components'


const GRID_SIZE_4 = 4

export const StyleYear = styled.div`
  flex:1;
  .body {
    display: flex;
    flex-wrap: wrap;
  }
  .calendar-year {
    width: calc(100% / ${GRID_SIZE_4})
  }
`
